export class CacheModel {
  expiresAt: Date;

  element: any;

  constructor(expiresAt: Date) {
    this.expiresAt = new Date();
  }
}